import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const setupBackgroundAnimation=(sectionRef)=>{
 const bgTiles=gsap.utils.toArray(".benefits-bg-tile",sectionRef.current);

 gsap.set(bgTiles,{
  opacity:0,
  scale:0.72,
  x:()=>gsap.utils.random(-45,45),
  y:()=>gsap.utils.random(-35,35),
  rotation:()=>gsap.utils.random(-5,5),
 });

 gsap.timeline({
  scrollTrigger:{
   trigger:sectionRef.current,
   start:"top 100%",
   end:"top 0%",
   scrub:1
  }
 }).to(bgTiles,{
  opacity:1,
  scale:1,
  x:0,
  y:0,
  rotation:0,
  stagger:{amount:1,from:"random"}
 });
};

export const setupEntranceAnimation=(sectionRef,kickerRef,titleRef,descriptionRef)=>{
 const cards=gsap.utils.toArray(".benefit-feature",sectionRef.current);

 gsap.set([kickerRef.current,titleRef.current,descriptionRef.current],{
  opacity:0,
  y:30
 });

 gsap.set(cards,{
  opacity:0,
  y:150,
  scale:0.95
 });

 const entranceTl=gsap.timeline({
  scrollTrigger:{
   trigger:sectionRef.current,
   start:"top 60%",
   end:"top 20%",
   scrub:1
  }
 });

 entranceTl.to([kickerRef.current,titleRef.current,descriptionRef.current],{
  opacity:1,
  y:0,
  duration:1,
  stagger:0.15,
  ease:"none"
 },0);

 entranceTl.to(cards,{
  opacity:1,
  y:0,
  scale:1,
  duration:1,
  stagger:0.1,
  ease:"none"
 },0.2);
};

export const setupPinnedAnimation=(sectionRef,kickerRef,titleRef,descriptionRef)=>{
 const cards=gsap.utils.toArray(".benefit-feature",sectionRef.current);

 const tl=gsap.timeline({
  scrollTrigger:{
   trigger:sectionRef.current,
   start:"top 60px",
   end:"+=300%",
   scrub:1,
   pin:true,
   pinSpacing:true,
   invalidateOnRefresh:true
  }
 });

 tl.to({},{duration:0.5});

 if(cards.length>0){
  const backCard=cards[0];
  const frontCards=cards.slice(1);

  if(kickerRef.current){
   tl.to(kickerRef.current,{
    opacity:0,
    duration:1,
    ease:"power2.inOut"
   },"step1");
  }

  if(descriptionRef.current){
   tl.to(descriptionRef.current,{
    opacity:0,
    duration:1,
    ease:"power2.inOut"
   },"step1");
  }

  if(titleRef.current){
   tl.to(titleRef.current,{
    x:()=>{
     let offsetLeft = 0;
     let el = titleRef.current;
     while(el && el !== sectionRef.current) {
      offsetLeft += el.offsetLeft;
      el = el.offsetParent;
     }
     const targetLeft=window.innerWidth<=600?20:window.innerWidth<=900?32:52;
     return targetLeft-offsetLeft;
    },
    y:()=>{
     let offsetTop = 0;
     let el = titleRef.current;
     while(el && el !== sectionRef.current) {
      offsetTop += el.offsetTop;
      el = el.offsetParent;
     }
     const targetTop=window.innerWidth<=600?100:120;
     const pinTop = 60;
     return targetTop-pinTop-offsetTop;
    },
    duration:1.2,
    ease:"power2.inOut"
   },"step1");
  }

  tl.to(backCard,{
   height:"65vh",
   y:"-40px",
   rotate:0,
   duration:2,
   ease:"power2.inOut"
  },"step1");

  if(frontCards.length>0){
   tl.to(frontCards,{
    scale:0.9,
    y:30,
    duration:2,
    ease:"power2.inOut"
   },"step1");
  }

  let stepNum=2;

  for(let i=1;i<cards.length;i++){
   tl.to(cards[i],{
    height:"65vh",
    y:"-40px",
    rotate:0,
    scale:1,
    duration:2,
    ease:"power2.inOut"
   },`step${stepNum}`);

   stepNum++;
  }
 }
};